module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/bg_equipment_sp-6dd11b22fdfa07b7e562997da5003cd9.png";